function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");
var _ref3 = /*#__PURE__*/React.createElement("defs", null);
var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Facility-Manager-app",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Tablet---Plattegrond-inzicht-3",
  transform: "translate(-959.000000, -531.000000)",
  stroke: "#425cd4",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  id: "Pijl-Copy",
  transform: "translate(962.000000, 536.000000) rotate(-360.000000) translate(-962.000000, -536.000000) translate(960.000000, 532.000000)"
}, /*#__PURE__*/React.createElement("polyline", {
  id: "Stroke-3",
  points: "0 8 4 4 0 0"
}))));
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6px",
    height: "10px",
    viewBox: "0 0 6 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8ABD3C63-8633-47A8-9DE4-93F9296B0910") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/Arrow Right.b5e2254ad8ee72751533fd9530dd53e9.svg";
export { ForwardRef as ReactComponent };